function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25",
  height: "17",
  viewBox: "0 0 512 336",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M512.001 251.862H0v75.034a8.829 8.829 0 008.828 8.828h494.345a8.829 8.829 0 008.828-8.828v-75.034z",
  fill: "#FF4B55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.001 168H0V9.103A8.829 8.829 0 018.828.275h494.345a8.829 8.829 0 018.828 8.828V168z",
  fill: "#FFE15A"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#41479B",
  d: "M0 168h512v83.862H0z"
}))));